module.exports = __webpack_public_path__ + "static/img/far1_active.db2c5565.png";